import React, { useState } from "react";
import api from "../../api/client";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import "./CreateClient.css";

const CreateClient: React.FC = () => {
  const token = useSelector((state: RootState) => state.user.token);

  const [clientName, setClientName] = useState("");
  const [contactInfo, setContactInfo] = useState("");
  const [maidName, setMaidName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [arrivalDate, setArrivalDate] = useState("");

  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const cleanClientName = clientName.trim();
    const cleanContactInfo = contactInfo.trim();
    const cleanMaidName = maidName.trim();
    const cleanAgentName = agentName.trim();

    if (!cleanClientName || !cleanContactInfo || !cleanMaidName) {
      setMessage("Client name, contact info, and maid name are required.");
      return;
    }

    if (!token) {
      setMessage("Your session has expired. Please sign in again.");
      return;
    }

    try {
      setSubmitting(true);
      setMessage("");

      const response = await api.post(
        "/create-client",
        {
          client_name: cleanClientName,
          contact_info: cleanContactInfo,
          maid_name: cleanMaidName,
          agent_name: cleanAgentName || null,
          arrival_date: arrivalDate || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { client_id } = response.data;

      console.log("New client created with ID:", client_id);

      setMessage("Client and maid created successfully.");

      setTimeout(() => {
        navigate("/clients");
      }, 1000);
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        (err?.message === "Network Error"
          ? "Unable to reach the server."
          : "An unexpected error occurred.");

      setMessage(msg);

      console.error("Error creating client:", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="create-client-container">
      <h2>Create New Client</h2>

      <form onSubmit={handleSubmit} className="create-client-form">
        <label>
          Client Name:
          <input
            type="text"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            required
          />
        </label>

        <label>
          Contact Info:
          <input
            type="text"
            value={contactInfo}
            onChange={(e) => setContactInfo(e.target.value)}
            required
          />
        </label>

        <label>
          Maid Name:
          <input
            type="text"
            value={maidName}
            onChange={(e) => setMaidName(e.target.value)}
            required
          />
        </label>

        <label>
          Agent Name:
          <input
            type="text"
            value={agentName}
            onChange={(e) => setAgentName(e.target.value)}
            placeholder="Optional"
          />
        </label>

        <label>
          Arrival Date:
          <input
            type="date"
            value={arrivalDate}
            onChange={(e) => setArrivalDate(e.target.value)}
          />
        </label>

        <p className="muted">
          Leave the arrival date empty if the maid has not arrived yet.
        </p>

        <button type="submit" disabled={submitting}>
          {submitting ? "Creating..." : "Create"}
        </button>
      </form>

      {message && <p className="feedback">{message}</p>}
    </div>
  );
};

export default CreateClient;
